import script from "./EditIntentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditIntentModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditIntentModal.vue?vue&type=style&index=0&id=5feb0ab3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5feb0ab3"]])

export default __exports__